/* 订单详情--支付记录组件 */
/* 订单详情---付款阶段组件 */
<template>
  <div class="payment-stage">
    <Table
      v-if="orderReceiveList"
      :columns="columns"
      :data="orderReceiveList"
      disabled-hover
      tooltip
    >
      <template slot-scope="{ row }" slot="applyTime">
        <div>
          <span v-if="row.applyTime">{{ row.applyTime | date }}</span>
          <span v-else>--</span>
        </div>
      </template>
      <template slot-scope="{ row }" slot="title">
        <div>{{ row.title }}</div>
      </template>
      <template slot-scope="{ row }" slot="actualAmount">
        <div v-if="row.actualAmount && row.actualAmount > 0">
          <span v-if="row.type === 2">{{
            row.actualAmount | currency("-¥", "2")
          }}</span>
          <span v-else>{{ row.actualAmount | currency("¥", "2") }}</span>
        </div>
        <div v-else>--</div>
      </template>
      <template slot-scope="{ row }" slot="paymentChannelDisplay">
        <div v-if="row.paymentChannelDisplay">
          {{ row.paymentChannelDisplay }}
        </div>
        <div v-else>--</div>
      </template>
      <template slot-scope="{ row, index }" slot="status">
        <span>{{ setStatus(row.status, row.type, index) }}</span>
      </template>
      <template slot-scope="{ row }" slot="accountName">
        <div v-if="row.accountName && row.remitCode">
          <span v-if="row.accountName && row.remitCode"
            >{{ row.remitCode }}/{{ row.accountName }}</span
          >
          <!-- <span v-else>--</span> -->
        </div>
        <div
          v-if="
            row.certificateFile &&
            row.type !== 2 &&
            !(row.accountName && row.remitCode)
          "
        >
          <a :href="ossPrefix + row.certificateFile.key" target="_blank">
            <Button size="small">查看详情</Button>
          </a>
        </div>
        <div
          v-if="
            (!row.accountName || !row.remitCode || row.type === 2) &&
            !row.certificateFile
          "
        >
          --
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        {
          title: "支付时间",
          slot: "applyTime",
          align: "center",
          width: 150,
        },
        {
          title: "内容",
          align: "center",
          slot: "title",
          width: 200,
        },
        {
          title: "金额",
          align: "center",
          slot: "actualAmount",
          width: 150,
        },
        {
          title: "支付方式",
          align: "center",
          slot: "paymentChannelDisplay",
          width: 200,
        },
        {
          title: "阶段支付状态",
          align: "center",
          slot: "status",
        },
        {
          title: "汇款识别码/甲方户名",
          align: "center",
          slot: "accountName",
          width: 250,
        },
      ],
    };
  },
  props: {
    ordersDetail: {
      type: [String, Object],
      default: "",
    },
    orderReceiveList: {
      type: [String, Array],
      default: "",
    },
  },
  methods: {
    /*  */
    setStatus(status, type, index) {
      switch (status) {
        case 100:
          if (type === 1) {
            return "已发起收款申请，待审核";
          } else if (type === 2) {
            return "待审核";
          }
          break;
        case 300:
          if (index === 0) {
            return "合同已确认";
          } else {
            return "已付清";
          }
        case 400:
          return "驳回";
          break;
        default:
          return "位置状态";
      }
    },
  },
};
</script>  